// @ts-strict-ignore
export const SHOW_ALL_ITEM = {
  isSpecialAction: true,
  icon: `caret-down`,
  isExpander: true,
  label: `Show all`,
};

export const SHOW_HIDDEN_SECTION_ITEM = {
  isSpecialAction: true,
  icon: `caret-down`,
  isExpander: true,
  label: `Show Hidden Matches`,
};

export const EXPANSION_TOGGLE_ITEM = {
  isSpecialAction: true,
};

export const SELECT_ALL_ITEM = {
  isSelectAll: true,
  label: ({t}) => t(`components.items-menu.select-all`),
  searchable: false,
};

export const DESELECT_ALL_ITEM = {
  isSelectAll: true,
  label: ({t}) => t(`components.items-menu.deselect-all`),
  searchable: false,
};

export const SELECT_ALL_MATCHING_ITEM = {
  isSelectAllMatching: true,
  label: ({t}) => t(`components.items-menu.select-all-matching`),
  searchable: false,
};

export const MAX_CSV_MATCHES = 5000;

export const PROGRESSIVE_SIZE = 100; // Render 100 items at first, as user scrolls, render more items as needed

export enum SelectionState {
  All = `all`,
  Some = `some`,
  None = `none`,
}

export const SUB_MENU_HOVER_DELAY_MS = 100;
